import { PaginatedRequest } from '../types/api';
import {
  FetchAnbPaymentDetailsResponse,
  FetchPaymentApiLogsResponse,
  FetchPaymentStatementsResponse,
  FetchAnbBalanceResponse,
  CreateDummyCompanyStatementRequest,
  CreateDummyCompanyStatementResponse,
  CreateDummyUserStatementRequest,
  CreateDummyUserStatementResponse,
  ProcessPendingStatementsResponse,
} from '../types/payment';
import { toQueryParams } from '../utils/request';
import { ApiService } from './common/ApiService';

class PaymentService extends ApiService {
  pathname = 'admin/payment';

  fetchAnbPaymentDetails = async (paymentId: string) =>
    this.get<FetchAnbPaymentDetailsResponse>(`${this.pathname}/anb/${paymentId}`);

  fetchStatements = async (data: PaginatedRequest) =>
    this.get<FetchPaymentStatementsResponse>(`${this.pathname}/statements?${toQueryParams(data)}`);

  fetchApiLogs = async (data: PaginatedRequest) =>
    this.get<FetchPaymentApiLogsResponse>(`${this.pathname}/api-logs?${toQueryParams(data)}`);

  fetchAnbBalance = async () => this.get<FetchAnbBalanceResponse>(`${this.pathname}/balance`);

  /** TESTING ONLY (refused in PROD) — a PENDING incoming statement to a company virtual bank. */
  createDummyCompanyStatement = async (data: CreateDummyCompanyStatementRequest) =>
    this.post<CreateDummyCompanyStatementResponse, CreateDummyCompanyStatementRequest>(
      `${this.pathname}/anb/create-dummy-statement`,
      data,
    );

  /** TESTING ONLY (refused in PROD) — a PENDING incoming statement to a user's (B2C) virtual bank. */
  createDummyUserStatement = async (data: CreateDummyUserStatementRequest) =>
    this.post<CreateDummyUserStatementResponse, CreateDummyUserStatementRequest>(
      `${this.pathname}/anb/create-dummy-user-statement`,
      data,
    );

  /** TESTING ONLY — runs the pending statements now instead of waiting for the cron. */
  processPendingStatements = async () =>
    this.post<ProcessPendingStatementsResponse, Record<string, never>>(
      `${this.pathname}/anb/process-pending-statements`,
      {},
    );
}

export const paymentService = new PaymentService();
